import EmailSVG from "@/assets/svg/enfinity-icons/mail.svg";
import SupportSVG from "@/assets/svg/enfinity-icons/support.svg";
import TelegramSVG from "@/assets/svg/enfinity-icons/telegram.svg";
import WhatsappSVG from "@/assets/svg/enfinity-icons/whatsapp.svg";
import YoutubeSVG from "@/assets/svg/enfinity-icons/youtube.svg";

export default function QuickLinks({ setModalOpen }) {
  const landingPage = import.meta.env.VITE_LANDING_PAGE;

  const socialPlatforms = [
    {
      icon: EmailSVG,
      name: "Email",
      url:
        landingPage === "vvv"
          ? "https://mail.google.com/mail/?view=cm&fs=1&to=support@veryviralvideos.com"
          : "https://mail.google.com/mail/?view=cm&fs=1&to=requests@enfinity.com",
    },
    {
      icon: TelegramSVG,
      name: "Telegram",
      url: "https://web.telegram.org/a/#6110481522",
    },
    {
      icon: YoutubeSVG,
      name: "Youtube",
      url: "https://www.youtube.com/@enfinity",
    },
    {
      icon: WhatsappSVG,
      name: "WhatsApp",
      url: "https://api.whatsapp.com/send/?phone=639291514853",
    },
    {
      icon: SupportSVG,
      name: "WhatsApp",
      action: () => setModalOpen(true),
    },
  ];

  return (
    <div className="flex items-center justify-center lg:justify-start gap-3">
      {socialPlatforms.map((platform, index) =>
        platform.action ? (
          <div
            key={index}
            className="rounded-lg w-14 md:w-16 h-12 flex justify-center items-center bg-transparent border border-white hover:bg-primary hover:border-0"
            onClick={platform.action}
          >
            <img src={platform.icon} className="w-6 h-6" alt={platform.name} />
          </div>
        ) : (
          <a key={index} href={platform.url} target="_blank">
            <div className="rounded-lg w-14 md:w-16 h-12 flex justify-center items-center bg-transparent border border-white hover:bg-primary hover:border-0">
              <img
                src={platform.icon}
                className="w-6 h-6"
                alt={platform.name}
              />
            </div>
          </a>
        )
      )}
    </div>
  );
}
